var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list',{staticClass:"goods"},_vm._l((_vm.goodsList),function(item){return _c('GoodsItem',{key:item.id,attrs:{"data":item,"double-row":+_vm.type === 1}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }